import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
    selector: 'products',
    template: `
        <mat-card fxLayoutAlign="center center">
            <mat-card-content>
                Coming Soon
            </mat-card-content>
        </mat-card>        
    `
})
export class ProductCatalogsComponent {

    constructor() {}            

}
